import { Button, Modal, UIHeading3 } from '@cian/ui-kit';

import * as React from 'react';

import styles from './styles.css';

export interface IDeleteModalProps {
  isOpen: boolean;
  onOpenChange: () => void;
  onDelete: () => void;
}

export const DeleteModal: React.FC<IDeleteModalProps> = ({ isOpen, onOpenChange, onDelete }) => {
  return (
    <Modal
      header={<UIHeading3>Удалить сохранённый поиск?</UIHeading3>}
      open={isOpen}
      onOpenChange={onOpenChange}
      body={
        <div className={styles['container']}>
          <Button fullWidth size="L" theme="fill_primary" onClick={onDelete}>
            Удалить
          </Button>
          <Button fullWidth size="L" theme="fill_secondary" onClick={onOpenChange}>
            Отмена
          </Button>
        </div>
      }
    />
  );
};
